/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { GetStaticProps } from 'next/types';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { NextSeo } from 'next-seo';
import { useLocation } from 'react-use';
import { getAgreementLatest } from '@/request/agreement';
import useUpdateWrapperMinWidthStyle from '@/hooks/useUpdateWrapperMinWidthStyle';
import style from './style.module.scss';
// import useHideIm from '@/hooks/useHideIm';

export type AgreementItem = {
  uuid: string;
  name: string;
  nameZh: string;
  version: string;
  agreementType: 'STU_CENTER_USER_AGREEMENT' | 'STU_CENTER_PRIVACY_POLICY';
  content: string;
  contentZh: string;
  enabled: true;
  whenModified: string;
  whenCreated: string;
};

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['home', 'common'])),
    },
  };
};
const titleMap = {
  STU_CENTER_USER_AGREEMENT: '用户协议',
  STU_CENTER_PRIVACY_POLICY: '隐私政策',
};

const Agreement = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation(['home', 'common']);
  const { agreementType = 'STU_CENTER_USER_AGREEMENT' } = router.query;
  const [detail, setDetail] = useState<AgreementItem>();
  const state = useLocation();
  // useHideIm(true);
  useUpdateWrapperMinWidthStyle(true);
  const handleAgreementLatest = async () => {
    const res = await getAgreementLatest(agreementType as AgreementItem['agreementType']);
    setDetail(res.data);
  };
  useEffect(() => {
    handleAgreementLatest();
  }, [agreementType]);
  const content = i18n.language === 'zh' ? detail?.contentZh || detail?.content : detail?.content;
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t(`home:${titleMap[agreementType as keyof typeof titleMap]}`),
          description: t('common:seo-隐私条款-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t(`home:${titleMap[agreementType as keyof typeof titleMap]}`),
            },
          ],
        }}
      />
      <Head>
        <title>{t(`home:${titleMap[agreementType as keyof typeof titleMap]}`)}</title>
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t(`home:${titleMap[agreementType as keyof typeof titleMap]}`)}
        />
        <style
          dangerouslySetInnerHTML={{
            __html: `
                #footer {
                    display: none !important;
                }
            `,
          }}
        />
      </Head>
      <div className={style.agreement}>
        <div className={style.agreementDetail} dangerouslySetInnerHTML={{ __html: content || '' }} />
      </div>
    </>
  );
};

export default Agreement;
